import { useAppContext } from 'hooks/context/useAppContext';
import { usePreferences } from 'hooks/preferences/usePreferences';

export const useBusiness = () => {
  const {
    publicUser: {
      multi_user: isMultiUser,
      business_address: address,
      business_address_latitude: addressLatitude,
      business_address_longitude: addressLongitude,
      business_email: email,
      business_name: name,
      business_phone: phone,
      phone: cellPhone,
      preferences: { business_hours: businessHours },
      instagram_url,
      facebook_url,
      yelp_url,
      twitter_url,
      website_url,
      pinterest_url,
    },
  } = useAppContext();

  const { isFixedLocation } = usePreferences();

  const addressLink = address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address,
      )}`
    : undefined;

  const socialMediaUrls = {
    instagram_url,
    facebook_url,
    yelp_url,
    twitter_url,
    website_url,
    pinterest_url,
  };

  return {
    address,
    addressLatitude,
    addressLink,
    addressLongitude,
    businessHours,
    cellPhone,
    email,
    isMultiUser,
    name,
    phone,
    showAddress: isFixedLocation && address?.length > 0,
    socialMediaUrls,
  };
};
